import { Workplace } from '../../../../graphql/graphql';
import { WorkplacesTreeItem } from '../../../Manager/Components/WorkplaceManager/ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';
import buildWorkplaceTree from './buildWorkplaceTree.helper';

export default function buildWorkplaceTreeWithRoot(
	items: Workplace[],
): WorkplacesTreeItem[] {
	if (!items.length) return [];
	const tree = buildWorkplaceTree(items);
	const rootInfo = items[0].rootWorkplace;
	if (rootInfo) {
		const rootNode: WorkplacesTreeItem = {
			...(items[0] as Workplace),
			id: rootInfo.id,
			name: rootInfo.name,
			type: 'main',
			children: tree,
		};
		return [rootNode];
	}
	return [];
}
